import React from 'react';
import { FallbackProps } from 'react-error-boundary';
import { Button } from 'components/buttons';

/**
 * Error fallback that makes sure the error is logged and renders a user
 * friendly message and a way to recover.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function MappingEditorErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  console.error('Mapping Editor crashed:', error);

  return (
    <section className="dp-mapping-editor-error-fallback">
      <p className="dp-mapping-editor-error-fallback__message">
        The Mapping Editor encountered a problem. Press "Reload" to reload the Mapping Editor.
      </p>
      <Button variant="primary" onClick={resetErrorBoundary}>
        Reload
      </Button>
    </section>
  );
}
